const ProductSwap = function () {
    const _openModaleSwappedProductsAddToCart = function ($modalTrigger, isPDP, isPLP) {
        let $tile = $modalTrigger.closest('.item-addToCart');
        let url = $modalTrigger.attr('swapped-products-target');
        let dataListNameOrigin = $tile.closest('[data-list-name]').data('list-name');

        $('.displayVarietiesActive').removeClass('displayVarietiesActive');
        $tile.addClass('in-progress displayVarietiesActive');
        $tile.addClass('in-progress');

        let productSwapData = {
            name: $tile.attr('data-product-name'),
            price: $tile.find('[data-main-price]').attr('data-main-price'),
            sku: $tile.attr('data-product-code'),
            brand: $tile.attr('data-product-brand'),
            category: $tile.attr('data-parent-category-hierarchy'),
            format: $tile.find('.head__unit-details').text(),
            department: $tile.attr('data-product-category'),
            merchandiseCategory: $tile.attr('data-merchandise-category'),
            dietry: $tile.attr('data-dietry')
        };

        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify(productSwapData),
            cache: false,
            success: function (data) {
                replaceContentModalOtherProducts(data, $tile, dataListNameOrigin, isPDP, isPLP);
                $('.product-upSell-container').addClass('swapped-products');
                UAEvents.defineDocument('.product-upSell-container.swapped-products .tile-product', false);
            },
            complete: function () {
                $tile.removeClass('in-progress');
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            }
        });
    }

    function replaceContentModalOtherProducts(data, productTile, dataListNameOrigin, isPDP, isPLP) {
        data = data.trim();
        upSellDisplay.displayUpsellSlide(data, productTile, dataListNameOrigin, isPDP, isPLP);
    }

    return {
        openModaleSwappedProductsAddToCart: _openModaleSwappedProductsAddToCart,
    }
}();

$(document).on('click', '.btn--displaySwappedProducts', function (event) {
    let isPLP = document.querySelectorAll('.products-search--grid').length;
    let isPlpBool = false;
    if (isPLP) {
        isPlpBool = true;
    }
    if ($(this).parents(".default-product-tile").hasClass("product-upSell-active")) {
        $(".close-upSell-panel").click();
        return;
    }
    if ($('.product-upSell-container').length) {
        $('.product-upSell-container').addClass('closing');
    }

    ProductSwap.openModaleSwappedProductsAddToCart($(event.currentTarget), false, isPlpBool);
});
